export const worldKo = {
  'world.seo.title': '세계',
  'world.seo.description':
    'Grymwyrd의 인터랙티브 지도들을 탐험하세요 — 왕국, 폐허, 그리고 전설의 장면들을 2D 지도와 회전 가능한 3D 지구본으로.',
  'world.heading': '세계',
  'world.intro':
    '영원한 황혼을 항해하세요. 이 지도책은 다층 시점을 위해 설계되었습니다 — 온 세계에서 단 하나의 던전까지 확대해보세요. 현재로선 최상층만 상호작용 가능하며, 영역들이 매핑되면 더 깊은 층들이 열릴 것입니다.',

  'world.viewMode.label': '지도 보기 모드',
  'world.viewMode.map2d': '2D 지도',
  'world.viewMode.globe3d': '3D 지구본',

  'world.gazetteer.navLabel': '위치 및 장면',
  'world.gazetteer.heading': '지명사전',
  'world.gazetteer.sampleNotice':
    '샘플 위치들을 보여주고 있습니다 — 지도 제작자의 진정한 조사는 아직 기록되지 않았습니다.',
  'world.gazetteer.error': '지도책 보관소에 접근할 수 없습니다.',

  'world.loading.atlas': '지도책을 펼치는 중…',
  'world.loading.globe': '세계를 회전시키는 중…',

  'world.layersActive': '{active}개/{total}개 레이어 활성화됨.',
  'world.globeHint':
    '드래그하여 회전 (탐험 중에는 자동 회전이 멈추고, 1분 동안 유휴 후 재개됨); 스크롤하여 확대. 육각형 위에 마우스를 올려 캠페인을 표시하고, 클릭하여 진입합니다.',
  'world.webglUnavailable':
    '3D 지구본은 WebGL이 필요하며, 여기에서는 사용할 수 없습니다 — 2D 지도를 대신 표시합니다.',

  'world.campaign.capitalRegion': '수도 지역',
  'world.campaign.territory': '캠페인 영토',
  'world.campaign.enter': '캠페인 진입',
  'world.campaign.stay': '궤도에 머물기',

  'world.layers.heading': '지도 레이어',
  'world.layers.gmBadge': 'GM',
  'world.layers.gmRequired': 'Game Master 역할이 필요합니다.',

  'world.marker.sampleBadge': '샘플 데이터',
  'world.marker.viewInEncyclopedia': '백과사전에서 보기',
  'world.marker.placeholderNote':
    '이것은 자리 표시자 위치입니다 — 배경이 작성되면 백과사전으로 링크됩니다.',

  'world.map2d.ariaLabel': '인터랙티브 오버월드 지도',
  'world.map2d.noOverworld': '오버월드 지도가 아직 그려지지 않았습니다 — 허공을 표시합니다',

  'world.globe.hint.enter': '진입 ▸',
  'world.globe.hint.open': '열기 ▸',
  'world.globe.hint.claim': '점유 ▸',
  'world.globe.uncharted': '미탐사 영역',
  'world.globe.unchartedBlurb':
    '영원한 황혼의 이 육각형에 캠페인이 점유하지 않았습니다. 첫 번째 깃발을 세우세요.',
  'world.globe.capitalLabel': 'Grymwyrd',
}
